// JIRA configuration types
export interface JiraConfig {
  domain: string;           // e.g., "your-domain.atlassian.net"
  email: string;            // JIRA user email
  apiToken: string;         // JIRA API token
  projectKey: string;       // Default project key
  issueType: string;        // Default issue type (Story, Task, etc.)
}

// JIRA issue types
export interface JiraIssue {
  id: string;
  key: string;              // e.g., "PROJ-123"
  summary: string;          // Issue title
  description?: string;     // Issue description
  storyPoints?: number | null; // Story points
  status: string;           // Issue status
  assignee?: string;        // Assignee username
  created: string;          // ISO timestamp
  updated: string;          // ISO timestamp
  issueType: string;        // Issue type
  projectKey: string;       // Project key
  resolutionDate?: string | null; // ISO timestamp when resolved
}

// Request types
export interface CreateIssueRequest {
  projectKey: string;
  summary: string;
  description?: string;
  issueType: string;
  storyPoints?: number;
  assignee?: string;
}

export interface UpdateIssueRequest {
  summary?: string;
  description?: string;
  storyPoints?: number;
  status?: string;
  assignee?: string;
}

export interface SyncToJiraRequest {
  issueKey?: string;        // Link to existing issue
  projectKey?: string;      // For creating new issue
  issueType?: string;       // For creating new issue
  createNew: boolean;       // true: create new, false: update existing
}

// Response types
export interface JiraSearchResult {
  issues: JiraIssue[];
  total: number;
  startAt: number;
  maxResults: number;
}

export interface JiraConnectionTestResult {
  success: boolean;
  message: string;
  user?: string;            // Authenticated user info
}

export interface SessionJiraSync {
  sessionId: string;
  issueKey: string;         // Linked JIRA issue key
  issueId: string;          // Linked JIRA issue ID
  syncedAt: string;         // ISO timestamp
  storyPoints: number;      // Synced story points
}

// Error types
export interface JiraError {
  errorMessages?: string[];
  errors?: { [key: string]: string };
}

// Local storage keys
export const JIRA_CONFIG_KEY = 'jira_config';
export const JIRA_ENABLED_KEY = 'jira_enabled';
